/* eslint-disable react/display-name */
/**
 * @file ProfilesManagementView.jsx
 * @author Fernando Ruano
 * @description Profiles Management View Page
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Helpers
import { sortString } from '@nephro/commons/helpers/utils';

// Components
import ManagementCrud from '@nephro/components/ManagementCrud';

/**
 * Profiles Management View
 * @param { Object } profileActions - Profile Actions.
 * @return { Node } React node.
 */
function ProfilesManagementView({ profileActions }) {
  const { t: translate } = useTranslation();
  const { getProfilesArray, deleteProfileById } = profileActions;

  // Table columns
  const columns = [
    {
      title: translate('commons.name'),
      dataIndex: 'name',
      sorter: sortString('name')
    },
    {
      title: translate('commons.description'),
      dataIndex: 'description',
      sorter: sortString('description')
    }
  ];

  return (
    <div className="h-full">
      <ManagementCrud
        getItemsArray={getProfilesArray}
        deleteItemById={deleteProfileById}
        columns={columns}
        deleteConfirmText={'profileMg.deleteProfile'}
        createButtonText={'profileMg.create'}
        itemIdKey={'id_profile'}
      />
    </div>
  );
}

/**
 * Component definition of proptypes.
 */
ProfilesManagementView.propTypes = {
  actions: PropTypes.shape({
    setLoading: PropTypes.func.isRequired
  }).isRequired,
  profileActions: PropTypes.shape({
    getProfilesArray: PropTypes.func.isRequired,
    deleteProfileById: PropTypes.func.isRequired
  }).isRequired,
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired,
  loading: PropTypes.bool
};

export default ProfilesManagementView;
